export const developer = {
  developers: 'Utvecklare',
  enpowerYourDevelopersToHarnessTheFullPotential: 'Bemyndiga dina utvecklare att utnyttja hela potentialen av din instrumentpanel',
  accessToken: 'Åtkomsttoken',
  yourAPI: 'Dina API:er',
  api: {
    apiManagement: 'API-hantering',
    apiManagementSubHeading: 'Lägg till, konfigurera, testa och hantera dina API:er som du kan använda för att utlösa i dina chat-flöden.',
    addApi: 'Lägg till API',
    createApi: 'Skapa en API',
    noApiFound: 'Inget API hittades!',
    deleteApis: 'Radera API:er',
    areYouSureYouWantToDeleteAPI: 'Är du säker på att du vill ta bort API:erna',
    placeholders: {
      search: 'Sök efter API-namn'
    },
    tableHead: {
      method: 'Metod',
      apiName: 'API-namn',
      url: 'URL',
      actions: 'Åtgärder'
    },
    parametersTab: 'Parametrar',
    headersTab: 'Headers',
    bodyTab: 'Body-flik',
    manageApiResponses: 'Hantera API-svar',
    chooseVariableToSave: 'Välj variabel att spara',
    selectCustomAttribute: 'Välj anpassat attribut',
    subTab: {
      key: 'Nyckel',
      enterKey: 'Ange nyckel',
      value: 'Värde',
      enterValue: 'Ange värde',
      addAnotherField: 'Lägg till ett annat fält',
      save: 'Spara',
      useslashToInsertCustomVariables: 'Använd "/" för att infoga anpassade variabler eller dynamiska värden från användarens svar.',
      response: 'Svar',
      apiRequestBody: 'API-begäran Body',
      hit: 'Träff',
      test: 'Test',
      buttonToGetAResponse: 'knapp för att få ett svar',
      variable: 'Variabel',
      saveToCustomAttribute: 'Spara till anpassat attribut',
      encryptedKey: 'Nyckel (Krypterad)',
      noOptionsAvailable: 'Inga tillgängliga alternativ',
      addAuthenticationField: 'Lägg till autentiseringsfält'

    },
    apiLogs: {
      apiManagement: 'API-hantering',
      addConfigureTestAndManageYourAPIs: 'Lägg till, konfigurera, testa och hantera dina API:er som du kan använda för att utlösa i dina chat-flöden.',
      searchHere: 'Sök efter statuskod',
      deleteApis: 'Radera API:er',
      testAnApi: 'Testa en API',
      noAPILogFound: 'Inga API-loggar hittades',
      responseCode: 'Svars-kod',
      message: 'Meddelande',
      apiResponse: 'API-svar',
      actions: 'Åtgärder',
      deleteAPIs: 'Radera API-loggar',
      areYouSureYouWantToDelete: 'Är du säker på att du vill ta bort denna API-logg?',
      apiLogs: 'API-loggar',
      subTitle: 'Detaljerad registrering av alla API-begäranden och svar som triggats inom chatflödet för chatbotten.'
    }
  },
  configApi: {
    configureApi: 'Konfigurera API',
    configureApiSubHeading: 'Du kan konfigurera ditt JSON-baserade API här och använda det för att förbättra ditt chat-flöde',
    apiLogs: 'API-loggar',
    test: 'Test',
    manageApiResponse: 'Hantera API-svar',
    body: 'Body',
    headers: 'Headers',
    parameters: 'Parametrar',
    testyourRequest: 'Testa din förfrågan',
    testRequestDescription: 'Din förfrågan innehåller variabler. Du kan manuellt ange deras värden för teständamål.',
    apiName: 'API-namn',
    placeholders: {
      enterApiName: 'Ange API-namn',
      enterApiUrl: 'Ange API-URL',
      enterTestValue: 'Ange testvärde',
    }
  }
};
